<section class="statement-dialog" *ngIf="showPopUp" [ngClass]="{
  'visible-ui': toShow === true,
  'invisible-ui': toShow === false
}">
<div class="modal-header">
  <button class="close-icon" [ngStyle]="{'color': baseSiteId === 'vsh' ? '#2EA857':'#78599D'}"
    (click)="activeModal.close();stService.reloadComponent.next(true)">X</button>
  <h4>{{"statementDisplay.monthly_statement" | cxTranslate}}</h4>
</div>
<div class="modal-body" [ngClass]="{
    'visible-ui': toShow === true,
    'invisible-ui': toShow === false
  }" #scrollableContent>
  <section class="makePaymentView" #content id="productList-areax" *ngIf="!!allStatementData">

    <!-- modal header -->
    <section class="row align-items-center header" data-html2canvas-ignore>
      <div class="col-sm-12 col-lg-3">
        <img class="statement-logo" *ngIf="baseSiteId === 'vsh'" src="../../assets/img/vs-us-logo-header.png"
          alt="vaccine_shop_us" />
        <img class="statement-logo" *ngIf="baseSiteId === 'vax'" src="../../assets/img/vax-logo.png"
          alt="vaccine_shop_us" />
      </div>
      <div class="quick-action-btns d-flex flex-row col-xs-12 col-sm-12 col-lg-5 offset-lg-4">
        <button class="btn-primary" (click)="onPrint()">
          <img src="../../../assets/icons/print-white.svg" alt="white_print">
          Print</button>
        <button class="btn-primary" (click)="generateSavePdf()">
          <img src="../../../assets/icons/pdf_white.png" [ngStyle]="{'height': '25px'}" alt="white_pdf">
          PDF</button>
      </div>
    </section>
    <!-- modal body -->
    <section class="acc-order-details main-content">

      <div class="row align-items-center balance-details">
        <div class="col-lg-3">
          <p>{{"statementDisplay.monthly_statement" | cxTranslate}}</p>
          <div class="address">

            <ul style="list-style-type: none;padding: 0;">
              <li>{{ allStatementData?.soldToAddress?.companyName }}</li>
              <li> {{ allStatementData?.soldToAddress?.line1 | uppercase }}
                {{ allStatementData?.soldToAddress?.line2 | uppercase }}</li>
              <li>
                {{ allStatementData?.soldToAddress?.town | uppercase }} &nbsp;
                {{
                allStatementData?.soldToAddress?.region?.isocodeShort
                | uppercase
                }}</li>
              <li>
                {{ allStatementData?.soldToAddress?.postalCode | uppercase }}
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-5">
          <label for="customer_no">Customer&nbsp;#{{allStatementData?.soldToAccount}}</label>
          <label for="stmnt_period">Statement Period&nbsp; {{ statement.toDte | date: "MM/dd/yyyy" }}</label>
        </div>
        <div class="col-lg-4">
          <div class="bal_container">
            <label class="balance">Balance:&nbsp;{{ calcTotalDiscounts(allStatementData?.statementTableData,
              'invoice') | currency:'USD'}}</label>
          </div>
        </div>
      </div>
      <!-- table starts -->
      <div class="row statement-info">
        <table class="table table-responsive col-md-12">
          <thead>
            <tr>
              <th class="col-md-1">Reference date</th>
              <th class="col-md-1">Reference #</th>
              <th class="col-md-2">PO Desc. #</th>
              <th class="col-md-1">Sold to acct</th>
              <th class="col-md-1">Due date</th>
              <th class="col-md-1">Scheduled card payment date</th>
              <th class="col-md-1"></th>
              <th class="col-md-1 bl-grey bt-grey">Early payment discount total</th>
              <th class="col-md-1 bt-grey br-grey">Total on or after due date</th>
            </tr>
          </thead>
          <tbody *ngIf="!!allStatementData">
            <!-- <tr *ngIf="allStatementData?.statementTableData.length === 0">
                  <td colspan="8">
                      {{ "statementDisplay.no_data" | cxTranslate }}
                  </td>
                </tr> -->
            <ng-container *ngFor="let stData of allStatementData?.statementTableData; let i = index">
              <tr *ngIf="stData.documentNumber && stData.documentNumber !== ''" class="entries">
                <td>{{stData.documentDate}}</td>
                <td>
                  <span *ngIf="asmStringCheck(stData?.referenceDocNo); else notAsmUser">
                    {{stData.documentNumber}}</span>
                  <ng-template #notAsmUser>
                    <a (click)="generateInvoicePDF(stData?.encryptedDocumentNumber)">{{stData.documentNumber}}</a>
                  </ng-template>
                </td>
                <td [ngStyle]="{'word-break': 'break-all'}">{{stData.poDescriptionNo}}</td>
                <td>{{stData.soldToAccountNo}}</td>
                <td>{{stData.dueDate}}</td>
                <td>{{ stData.termsOfPayment.charAt(0) == 'F' ? getScheduledPaymentDate(stData.dueDate) : ''}}</td>
                <td style="text-align: end;">--</td>
                <td class="bl-grey">({{stData.discount | currency:'USD'}})</td>
                <td class="br-grey">
                  <span *ngIf="stData.transType.toLowerCase() == 'invoice'">{{stData.amountDue |
                    currency:'USD'}}</span>
                  <span *ngIf="stData.transType.toLowerCase() == 'credit memo'">({{stData.amountDue |
                    currency:'USD'}})</span>
                </td>
              </tr>
            </ng-container>
            <tr>
              <td colspan="6" *ngIf="!allStatementData?.statementTableData.length"
                [ngStyle]="{'text-align': 'center'}">{{"statementDisplay.no_data" | cxTranslate}}</td>
              <td colspan="6" *ngIf="allStatementData?.statementTableData.length"></td>
              <td></td>
              <td class="bl-grey bb-grey">({{calcTotalDiscounts(allStatementData?.statementTableData,'discount') |
                currency: 'USD'}})</td>
              <td class="br-grey bb-grey">{{calcTotalDiscounts(allStatementData?.statementTableData, 'invoice') |
                currency: 'USD'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--table ends-->
      <div class="row remittance-wrapper">
        <div class="col-sm-12 col-md-7 col-lg-6 payment-summary">
          <!-- <div class="row">
                <div class="col-md-6">Summary of payment information:</div>
                <div class="col-md-6">{{statement.fromDte | date: 'MM/dd/yyyy'}} - {{statement.toDte | date: 'MM/dd/yyyy'}}</div>
              </div> -->
          <!-- <div class="row">
                <div class="col-md-6">Total amount of check payments:</div>
                <div class="col-md-6">$0.00</div>
              </div>
              <div class="row">
                <div class="col-md-6">Total amount of credit card payments:</div>
                <div class="col-md-6">$0.00</div>
              </div>
              <div class="row">
                <div class="col-md-6">Total amount of electronic check payments:</div>
                <div class="col-md-6">$0.00</div>
              </div>
              <div class="row">
                <div class="col-md-6">Last check payment amount:</div>
                <div class="col-md-6">$0.00</div>
              </div>
              <div class="row">
                <div class="col-md-6">Last check payment date:</div>
                <div class="col-md-6"></div>
              </div>
              <div class="row">
                <div class="col-md-6">Last check number received:</div>
                <div class="col-md-6"></div>
              </div> -->
        </div>
        <div class="col-sm-12 col-md-5 col-lg-4 offset-lg-2 remittance">
          <p>For remittance please enter the payment amount(s).</p>
          <div class="remittance_address">
            <label for="title">Remittance address</label>
            <ul style="list-style-type: none;padding-left: 0;" *ngIf="baseSiteId == 'vax';else vshRemitAddr">
              <li>VAXSERVE</li>
              <li>12566 COLLECTIONS CENTER DRIVE</li>
              <li>CHICAGO, IL, US 60693</li>
            </ul>
            <ng-template #vshRemitAddr>
              <ul style="list-style-type: none;padding-left: 0;">
                <li>SANOFI PASTEUR INC</li>
                <li>12458 COLLECTIONS CENTER DR</li>
                <li>CHICAGO, IL, US 60693</li>
              </ul>
            </ng-template>

          </div>
          <p class="query" [ngStyle]="{'word-break': 'break-all'}" *ngIf="baseSiteId == 'vsh'">If you have any
            questions please call us at
            1-800-VACCINE (1-800-822-2463) or email us at <a href="mailto:customer.accounts&#64;sanofi.com">
              customer.accounts&#64;sanofi.com</a>
          </p>
          <p class="query" [ngStyle]="{'word-break': 'break-all'}" *ngIf="baseSiteId == 'vax'">If you have any
            questions please call us at
            1-800-752-9338 or email us at <a href="mailto:VaxServe&#64;vaxserve.com">
              VaxServe&#64;vaxserve.com</a>
          </p>
        </div>
      </div>
      <div class="row payment-constraints">
        <div class="col-md-7 col-lg-6 payment-constraints__1">
          <p>**Invoice(s) scheduled to be paid by credit card on scheduled payment date (3 days before due date).</p>
          <ul style="list-style-type: none;padding: 0;">
            <li>Please disregard statement if payment has been made in the past 10 days.</li>
            <li>Payments not referencing open items will be applied to the oldest invoice.</li>
            <li>For your convenience, we also accept Visa®, MasterCard®, Discover®, American Express® and Electronic
              Check Payment.</li>
            <li>Federal Excise Tax must be collected from customers even if they are exempt from state sales, use
              and/or excise tax.</li>
          </ul>
        </div>
        <div class="col-md-5 col-lg-4 offset-lg-2 payment-constraints__2">
          <label for="correspondence">Correspondence other than payments</label>

          <ul style="list-style-type: none;padding: 0; word-break: break-all;"
            *ngIf="baseSiteId == 'vsh';else vaxCorresAddr">
            <li>SANOFI PASTEUR INC.</li>
            <li>DISCOVERY DRIVE</li>
            <li>SWIFTWATER, PA, US 18370-0187</li>
            <li>ATTN: CUSTOMER ACCOUNT MANAGEMENT</li>
          </ul>
          <ng-template #vaxCorresAddr>
            <ul style="list-style-type: none;padding: 0; word-break: break-all;">
              <li>VAXSERVE INC.</li>
              <li>54 GLENMAURA NATIONAL BLVD STE 301</li>
              <li>MOOSIC, PA, US 18507-2101</li>
              <li>ATTN: CUSTOMER ACCOUNT MANAGEMENT</li>
            </ul>
          </ng-template>
        </div>
      </div>
    </section>
    <!-- modal footer -->
    <section class="footer" *ngIf="baseSiteId == 'vsh'">
      <div class="row">
        <div class="col-sm-12 col-md-4 col-lg-4">
          &copy;&nbsp;2020 Sanofi Pasteur Inc.
        </div>
        <div class="col-sm-12 col-md-4 offset-md-4 col-lg-2 offset-lg-6" data-html2canvas-ignore>
          <img src="../../../assets/img/sanofi-pasteur-logo-color.png" alt="sanofi_pasteur_logo"
            [ngStyle]="{'max-width': '100%'}">
        </div>
      </div>
    </section>


  </section>
</div>
</section>